import { AppletFrame } from '@/features/applets/AppletFrame';

import type { HeadingLevel } from './TextUnit';
import type { AppletUnitData } from './useComponent';
import { CaptionText } from './CaptionText';
import styles from './IframeUnit.module.css';

interface AppletUnitProps {
  headingLevel?: HeadingLevel;
  hideHeading?: boolean;
  unit: AppletUnitData;
}

function clampHeadingLevel(level: HeadingLevel | undefined): HeadingLevel {
  if (!level) {
    return 2;
  }

  return Math.min(4, Math.max(2, level)) as HeadingLevel;
}

export function AppletUnit({
  headingLevel,
  hideHeading = false,
  unit,
}: AppletUnitProps) {
  const HeadingTag = `h${clampHeadingLevel(headingLevel)}` as const;
  const visibleHeading = hideHeading
    ? null
    : unit.numberedHeading ?? unit.heading ?? null;

  return (
    <article className={styles.unit}>
      {visibleHeading ? (
        <HeadingTag className={styles.heading} id={unit.anchorId}>
          {visibleHeading}
        </HeadingTag>
      ) : null}

      <AppletFrame
        appletId={unit.appletId}
        version={unit.version}
        config={unit.config}
        title={unit.title}
        srcOverride={unit.srcOverride}
        sandbox={unit.sandbox}
        fixedHeight={unit.fixedHeight}
        resettable={unit.resettable}
        resetLabel={unit.resetLabel}
      />

      {unit.caption ? (
        <p className={styles.caption}>
          <CaptionText text={unit.caption} />
        </p>
      ) : null}
    </article>
  );
}
